import Typography from "@mui/material/Typography";
import { LegalDocument } from "../components/LegalDocument";
import { PLATFORM_LEGAL_DISPLAY_NAME } from "@bw/shared";

/** Public terms for the optional Badminton Warriors transactional SMS program. */
export function SmsTermsPage() {
  return (
    <LegalDocument title="Transactional SMS terms" updated="October 27, 2026">
      <p>
        {PLATFORM_LEGAL_DISPLAY_NAME}
        offers optional account and transaction text messages to players.
        Read the public <a href="/messaging-program">messaging program overview</a>.
        These SMS terms supplement our general <a href="/terms">Terms of Service</a>.
      </p>

      <h2>What we text</h2>
      <p>
        If you request phone verification, we send a one-time verification code
        for that request. After verifying your phone, you can separately opt in
        to transactional texts about payments, refunds, visits, classes,
        tournaments, and leagues. These can include confirmations, required
        payment actions, reminders, cancellations, registration changes, and
        schedule or venue changes. You can control Payments, Classes, and
        Tournaments &amp; leagues separately in notification settings. We do not
        use this program for marketing messages. Message frequency varies with
        your verification requests and account activity.
      </p>

      <h2>Your choice and charges</h2>
      <p>
        Transactional texts are off by default. You can use Badminton Warriors
        and make a purchase without opting in; SMS consent is optional and is
        not a condition of purchase. Message and data rates may apply according
        to your mobile plan.
      </p>

      <h2>Stop texts or get help</h2>
      <p>
        Reply STOP to cancel future texts, or turn off Transactional text
        messages in your account settings. Reply HELP for assistance, or email
        {" "}
        <a href="mailto:support@badmintonwarriors.com">
          support@badmintonwarriors.com
        </a>.
      </p>

      <h2>Delivery and privacy</h2>
      <p>
        Mobile carriers are not liable for delayed or undelivered messages.
        Text delivery is not guaranteed; your in-app transaction confirmation
        remains available even if a text does not arrive. Our{" "}
        <a href="/privacy">Privacy Policy</a> explains how we use your phone
        number and SMS opt-in information.
      </p>
    </LegalDocument>
  );
}
